import InviteApplicantsContainer from './invite_applicants_container';

const InviteApplicants = InviteApplicantsContainer;
export default InviteApplicants;
